import React from 'react';

export default function LanguageToggle({ lang, setLang }) {
  const languages = [
    { code: 'es', label: 'ES' },
    { code: 'en', label: 'EN' },
    { code: 'pt', label: 'PT' }
  ];

  return (
    <div className="flex bg-gray-100 p-1 rounded-full w-fit mx-auto mb-6 shadow-inner border border-gray-200/50">
      {languages.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={`px-4 py-1.5 rounded-full text-[10px] font-black tracking-widest transition-all duration-300 ${
            lang === l.code 
              ? 'bg-emerald-800 text-white shadow-lg scale-105' 
              : 'text-gray-400 hover:text-gray-600'
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}